import {apiGetCall, apiPostCall} from "./index";

export const load   = group => apiGetCall("/groupmessages/get", {group});
export const send   = (group, message, duration, urgent) => apiPostCall("/groupmessages/send", {group, message, duration, urgent});
export const cancel = uuid => apiPostCall("/groupmessages/cancel", {uuid});
